<nz-card nzTitle="Maintenance management system">
  <nz-tabs class="em-tabs-full-width" nzTabPosition="top" nzType="card">
    <nz-tab nzTitle="Cost">
      <em-cost-details></em-cost-details>
    </nz-tab>
    <nz-tab nzTitle="History">
      <em-history-details></em-history-details>
    </nz-tab>
    <nz-tab nzTitle="MTS">
      <em-mould-technical-specification></em-mould-technical-specification>
    </nz-tab>
  </nz-tabs>
</nz-card>
